import React, {Suspense, useEffect} from 'react';
import {Switch, Route} from "react-router-dom";
import './App.css';
import PageLoading from "../components/PageLoading";
import {useDispatch, useSelector} from "react-redux";
import {Dispatch, RootState} from "../models";
import {BackTop, Spin} from "antd";
import {Helmet} from "react-helmet";
import ProductPicture from "./product/picture";

const Login = React.lazy(() => import('./login'))
const Index = React.lazy(() => import('./index'))

function App() {

    const appDispatch = useDispatch<Dispatch>().app
    const siteConfigs = useSelector((state: RootState) => state.app.siteConfigs)

    useEffect(() => {
        appDispatch.loadSiteConfigs()
    }, [appDispatch])

    return (
        <div className="App">
            <Helmet>
                <title>{`${siteConfigs?.title || ''}`}</title>
            </Helmet>
            <BackTop/>
            {siteConfigs ? (
                <Suspense fallback={<PageLoading/>}>
                    <Switch>
                        <Route path={'/product/picture/:model'} component={ProductPicture}/>
                        <Route path={'/login'} component={Login}/>
                        <Route path={'/'} component={Index}/>
                    </Switch>
                </Suspense>
            ) : (
                <div style={{display: "flex", height: '100%', justifyContent: "center", alignItems: "center"}}>
                    <Spin size={"large"} spinning/>
                </div>
            )}
        </div>
    );
}

export default App;
